{
  "select": "Seleccione",
  "save": "Guardar!",
  "SelectYour": "Seleciona tu",
  "Photo": "foto",
  "photoLimit": "Buena foto, pero supera el tamaño máximo: 10 MB.",
  "skip": "Saltar por ahora",
  "selectAvatar": "Seleciona tu avatar",
  "UploadProfile": "Subir perfil"
}
